module.exports = __webpack_public_path__ + "static/media/cut.91a51824.ico";